import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  Card,
  CardMedia,
  CardContent,
  Paper,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Box,
  Button,
} from "@material-ui/core";
import CircularProgress from "@mui/material/CircularProgress";
import { green } from "@mui/material/colors";
import CheckIcon from "@mui/icons-material/Check";
import LeftNav from "./LeftNav";
import "./SI180Dashboard.css";
import Pagination from "@material-ui/lab/Pagination";
import { fetchCategoryItems } from "services/api/si180Api";

const primColor = process.env.REACT_APP_SI180_PRIMCOLOR;
const textColor = process.env.REACT_APP_TEXT_COLOR;
const btnColor = process.env.REACT_APP_SI180_BTNCOLOR;
const greyColor = process.env.REACT_APP_SI180_BGGREY;
const siteMedSrc = process.env.REACT_APP_MEDIA_SRC;
const secColor = process.env.REACT_APP_SI180_SECCOLOR;
const itemsPerPage = 8; // Number of items you want per page

const ResidentMenuItems = ({ onResidentLookup }) => {
  const [checkNumber] = useState("12345");
  const [currentUser] = useState({
    firstName: JSON.parse(sessionStorage.getItem("selectedCustomer")).FirstName,
    lastName: JSON.parse(sessionStorage.getItem("selectedCustomer")).LastName,
  });
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(1);
  const [resetPage, setResetPage] = useState(false);

  const [menuItems, setMenuItems] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(
    sessionStorage.getItem("selectedCategory")
  );

  useEffect(async () => {
    try {
      const data = await fetchCategoryItems();
      setMenuItems(data);
    } catch (error) {
      console.error("fetchCategoryItems failed:", error);
    }
  }, [selectedCategory]);

  useEffect(() => {
    // This effect runs when the component mounts
    const handleStorageChange = () => {
      // Update state when session storage changes
      setSelectedCategory(sessionStorage.getItem("selectedCategory"));
    };

    // Listen for custom events that signal session storage changes
    window.addEventListener("storageChange", handleStorageChange);

    // Cleanup to remove the event listener
    return () => {
      window.removeEventListener("storageChange", handleStorageChange);
    };
  }, []);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setPage(1); // Reset to first page on search
  };

  const handlePageChange = (event, value) => {
    if (resetPage) {
      // If resetPage is true, always reset to page 1
      setPage(1);
      // Reset the flag so subsequent page changes work as expected
      setResetPage(false);
    } else {
      // Regular page change based on user selection
      setPage(value);
    }
  };

  // Example function that triggers a reset to page 1
  const someActionThatRequiresPageReset = () => {
    // Set the flag to true to indicate the next page change should reset to page 1
    setResetPage(true);
    // Perform the action that requires the page to be reset (like applying a filter)
  };

  const filteredItems =
    menuItems.length > 0
      ? menuItems.filter((item) =>
          item.ItemName.toLowerCase().includes(searchQuery.toLowerCase())
        )
      : [];

  const paginatedItems =
    filteredItems.length > 0 &&
    filteredItems.slice((page - 1) * itemsPerPage, page * itemsPerPage);

  const [orderOption, setOrderOption] = useState("orderToday");

  const handleOrderOptionChange = (event) => {
    setOrderOption(event.target.value);
  };

  const [loading, setLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const timer = React.useRef();

  const buttonSx = {
    ...(success
      ? {
          bgcolor: "#265E08",
          "&:hover": {
            bgcolor: green[700],
          },
        }
      : {
          backgroundColor: "#265E08", // Default color when not in success state
        }),
    color: textColor,
  };

  React.useEffect(() => {
    return () => {
      clearTimeout(timer.current);
    };
  }, []);

  const handleButtonClick = () => {
    if (!loading) {
      setSuccess(false);
      setLoading(true);
      timer.current = setTimeout(() => {
        setSuccess(true);
        setLoading(false);
      }, 2000); // Simulates a 2-second loading process
    }
  };

  return (
    <div className="dashboard">
      <LeftNav onResidentLookup={onResidentLookup} />
      <div className="right-pane" style={{ backgroundColor: "white" }}>
        <Typography
          variant="h4"
          style={{
            textAlign: "center",
            color: primColor,
          }}
        >
          Order for {currentUser.firstName} {currentUser.lastName}
        </Typography>
        <Paper
          style={{ padding: 10, backgroundColor: btnColor, marginTop: "1rem" }}
        >
          <Grid container className="resMenu" alignItems="center">
            <Grid item>
              <Typography variant="h5" style={{ color: textColor }}>
                {sessionStorage.getItem("selectedMenu")}
              </Typography>
              <Typography variant="subtitle1" style={{ color: textColor }}>
                Check Number: {checkNumber}
              </Typography>
            </Grid>
            <Grid item>
              <input
                className="si180btn"
                type="text"
                placeholder="Search..."
                // variant="outlined"
                value={searchQuery}
                onChange={handleSearchChange}
              />
            </Grid>
          </Grid>
        </Paper>
        <Grid container spacing={2} justify="left" style={{ marginTop: 10 }}>
          {paginatedItems.length > 0 &&
            paginatedItems.map((item, index) => (
              <Grid item key={index} xs={12} sm={6} md={4} lg={3}>
                <Card
                  style={{
                    cursor: "pointer",
                    height: "230px",
                    backgroundColor: greyColor,
                  }}
                >
                  <CardMedia
                    style={{ height: 90 }}
                    image={siteMedSrc + item.FileName}
                    title={item.ItemName}
                  />
                  <CardContent style={{ paddingBottom: ".5rem" }}>
                    <Typography
                      gutterBottom
                      variant="h6"
                      style={{
                        display: "-webkit-box",
                        WebkitLineClamp: 1,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                      }}
                    >
                      {item.ItemName}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      style={{
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                      }}
                    >
                      {item.ItemDescription}
                    </Typography>
                    <Typography
                      variant="h6"
                      style={{
                        fontWeight: "bold",
                        color: "#E53935",
                        lineHeight: 2,
                        // textAlign: "right",
                      }}
                    >
                      {parseFloat(item.DefaultPrice / 100).toLocaleString(
                        "en-US",
                        {
                          style: "currency",
                          currency: "USD",
                          minimumFractionDigits: 2,
                        }
                      )}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
        </Grid>

        {filteredItems.length > itemsPerPage && (
          <Pagination
            count={Math.ceil(filteredItems.length / itemsPerPage)}
            page={page}
            onChange={handlePageChange}
            color="primary"
            style={{
              marginTop: 20,
              justifyContent: "center",
              display: "flex",
              listStyleType: "none",
            }}
          />
        )}

        <Grid
          container
          justify="center"
          alignItems="center"
          style={{ marginTop: 10 }}
        >
          <FormControl component="fieldset">
            <RadioGroup
              row
              aria-label="order"
              name="order1"
              value={orderOption}
              onChange={handleOrderOptionChange}
            >
              <Box borderRadius="borderRadius" p={1}>
                {/* Apply background color and padding */}
                <FormControlLabel
                  value="orderToday"
                  control={<Radio />}
                  label="Order Today"
                  style={{
                    backgroundColor:
                      orderOption === "orderToday" ? btnColor : secColor, // Change color based on selection
                    borderRadius: 4,
                    margin: ".25rem",
                    color: textColor,
                    padding: ".5rem 1rem .5rem 0",
                    textAlign: "center",
                  }}
                />
                <FormControlLabel
                  value="orderTomorrow"
                  control={<Radio />}
                  label="Order Tomorrow"
                  style={{
                    backgroundColor:
                      orderOption === "orderTomorrow" ? btnColor : secColor, // Change color based on selection
                    borderRadius: 4,
                    margin: ".25rem",
                    color: textColor,
                    padding: ".5rem 1rem .5rem 0",
                    textAlign: "center",
                  }}
                />
                <FormControlLabel
                  value="orderNow"
                  control={<Radio />}
                  label="Order Now"
                  style={{
                    backgroundColor:
                      orderOption === "orderNow" ? btnColor : secColor, // Change color based on selection
                    borderRadius: 4,
                    margin: ".25rem",
                    color: textColor,
                    padding: ".5rem 1rem .5rem 0",
                    textAlign: "center",
                  }}
                />
              </Box>
            </RadioGroup>
          </FormControl>
        </Grid>
        <Box sx={{ textAlign: "center", marginTop: 20 }}>
          <Box sx={{ position: "relative", display: "inline-flex" }}>
            <Button
              className="si180btn"
              sx={buttonSx}
              disabled={loading}
              onClick={handleButtonClick}
              style={{
                backgroundColor: "#265E08",
                color: textColor,
                width: "250px",
                height: "72px",
                display: "flex", // Ensure the contents of the button are inline
                alignItems: "center", // Align the icon and text vertically
                justifyContent: "center", // Center the icon and text horizontally
              }}
              startIcon={
                success ? (
                  <CheckIcon />
                ) : (
                  <img
                    src={siteMedSrc + "AutoPay" + ".svg"}
                    alt="AutoPay Icon"
                    style={{
                      height: "42px", // Set the icon size, adjust as needed
                      marginRight: "4px", // Add some space between the icon and the text
                    }}
                  />
                )
              } // Show check icon when success
            >
              {success ? "Success" : "Process AutoPay"}
            </Button>
            {loading && (
              <CircularProgress
                size={42}
                sx={{
                  color: green[500],
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  marginTop: "-18px", // Adjust these values as needed to center the spinner
                  marginLeft: "-12px",
                }}
              />
            )}
          </Box>
        </Box>
      </div>
    </div>
  );
};

export default ResidentMenuItems;
